import { useEffect, useRef } from 'react';
import { Loader } from '../../atoms';
import './style.scss';
import momentjs from 'moment';

const ChatMessageList = ({ messages, loading }) => {
  const ref = useRef(null);

  console.log("messages: ", messages);

  useEffect(() => {
    if (ref.current && !loading) {
      ref.current.scrollTop = ref.current.scrollHeight;
    }
  }, [messages, loading])

  return (
    <div className="chat-message-list " ref={ref}>
      {loading ?
        <div className="loader">
          <Loader />
        </div>
        :
        <div className="d-flex justify-content-end flex-column py-3">
          {
            messages.map((message, i) => (
              <div key={i} className={`message ${message.send_by_user ? 'client' : 'admin'}`}>
                <p>{message.text}</p>
                <span className="date">{momentjs(message.created_at.toDate()).format('DD/MM/YYYY')}</span>
              </div>
            ))
          }
        </div>
      }
    </div>
  );
}

export { ChatMessageList };
